/* LABETA verificador de precio entregado por CP — v1.3.1 (VITRA)
   v1.1: el CP auto-selecciona el Estado en el selector de la ficha.
   v1.2: cp_check se envia DIRECTO a GA4 (G-VD25X90WHN) via gtag lazy-load —
         el contenedor GTM del sitio (WDVBK6T) no esta accesible para crear trigger;
         gtag se carga SOLO cuando el usuario teclea un CP (cero costo si no se usa),
         config con send_page_view:false (no duplica pageviews). Dedupe por CP.
   v1.3 (12-sep): lista OVERRIDES de CPs cubiertos que faltan en el asset delta-encoded —
         espejo de CP_DIRECTA_OVERRIDE en n8n Validar Cobertura CP (caso 45380 Tonala).
   v1.3.1 (12-sep): +11 CPs validados contra frecuencias Estafeta y aprobados por Carlos
         (auditoria 30 dias: Cuautitlan, Atizapan, Naucalpan, Huixquilucan, CDMX x4,
         Cd. Madero, Villa de Alvarez) — sync con n8n v1.5. Al regenerar labeta-cp-data.js
         desde n8n, vaciar OVERRIDES.
         NOTA: archivo renombrado a labeta-cp-v13.js porque el pipeline de minificado
         de Shopify quedo atorado sirviendo el build viejo de labeta-cp.js.
   Datos de cobertura en assets/labeta-cp-data.js (window.__labetaCpD). */
(function(){
  'use strict';
  if (location.pathname.indexOf('/products/') === -1) return;
  var S = null;
  var OVERRIDES = [45380, 54740, 52938, 52764, 53100, 53126, 6040, 1730, 5500, 10000, 89506, 28978]; /* CPs cubiertos fuera del asset — mantener en sync con n8n v1.5 */
  function buildSet(){
    if (S) return S;
    S = {};
    var D = window.__labetaCpD || '';
    var rows = D.split(';');
    for (var r = 0; r < rows.length; r++) {
      var ds = rows[r].split(',');
      var cp = parseInt(ds[0], 10);
      S[cp] = 1;
      for (var i = 1; i < ds.length; i++) { cp += parseInt(ds[i], 10); S[cp] = 1; }
    }
    for (var o = 0; o < OVERRIDES.length; o++) { S[OVERRIDES[o]] = 1; }
    return S;
  }
  var A1 = 120, A2 = 4000; /* parametros de entrega */
  /* prefijo CP (2 digitos) -> nombre de estado como aparece en el selector */
  var E = [[0,16,'CDMX'],[20,20,'Aguascalientes'],[21,22,'Baja California'],[23,23,'Baja California Sur'],[24,24,'Campeche'],[25,27,'Coahuila'],[28,28,'Colima'],[29,30,'Chiapas'],[31,33,'Chihuahua'],[34,35,'Durango'],[36,38,'Guanajuato'],[39,41,'Guerrero'],[42,43,'Hidalgo'],[44,49,'Guadalajara'],[50,57,'Edo. de Mexico'],[58,61,'Michoacan'],[62,62,'Morelos'],[63,63,'Nayarit'],[64,67,'Nuevo Leon'],[68,71,'Oaxaca'],[72,75,'Puebla'],[76,76,'Queretaro'],[77,77,'Quintana Roo'],[78,79,'San Luis Potosi'],[80,82,'Sinaloa'],[83,85,'Sonora'],[86,86,'Tabasco'],[87,89,'Tamaulipas'],[90,90,'Tlaxcala'],[91,96,'Veracruz'],[97,97,'Yucatan'],[98,99,'Zacatecas']];
  function norm(s){
    s = (s || '') + '';
    try { s = s.normalize('NFD').replace(/[̀-ͯ]/g, ''); } catch(e) {}
    return s.toLowerCase().replace(/\./g, '').replace(/\s+/g, ' ').trim();
  }
  function stateForCp(cp){
    var p = Math.floor(parseInt(cp, 10) / 1000);
    for (var i = 0; i < E.length; i++) { if (p >= E[i][0] && p <= E[i][1]) return E[i][2]; }
    return null;
  }
  function findStateSelector(){
    var sels = document.querySelectorAll('.single-option-selector');
    for (var i = 0; i < sels.length; i++) {
      var sel = sels[i];
      var lbl = sel.id ? document.querySelector('label[for="' + sel.id + '"]') : null;
      if (lbl && /estado/i.test(lbl.textContent)) return sel;
      for (var j = 0; j < sel.options.length; j++) {
        if (norm(sel.options[j].value) === 'guadalajara') return sel;
      }
    }
    return null;
  }
  function autoState(cp){
    var target = stateForCp(cp);
    if (!target) return false;
    var sel = findStateSelector();
    if (!sel) return false;
    var opt = null;
    for (var j = 0; j < sel.options.length; j++) {
      if (norm(sel.options[j].value) === norm(target)) { opt = sel.options[j]; break; }
    }
    if (!opt) return false; /* el producto no tiene ese estado: no tocar nada */
    if (sel.value !== opt.value) {
      sel.value = opt.value;
      sel.dispatchEvent(new Event('change', { bubbles: true }));
      return true; /* Debut repintara el precio */
    }
    return false;
  }
  function qty(){
    var q = document.getElementById('Quantity');
    var v = q ? parseFloat(q.value) : 20;
    return (v && v > 0) ? v : 20;
  }
  function unitPrice(){
    var el = document.querySelector('.labeta-product__price-amount');
    if (!el) return null;
    var m = (el.textContent || '').replace(/[^0-9.]/g, '');
    var v = parseFloat(m);
    return isNaN(v) ? null : v;
  }
  function compute(cp){
    var u = unitPrice();
    if (u === null) return null;
    var covered = !!buildSet()[parseInt(cp, 10)];
    var q = qty();
    var extra = covered ? 0 : Math.max(A1, A2 / q);
    var unitFinal = Math.round(u + extra);
    var total = Math.round(unitFinal * q);
    return { covered: covered, unit: unitFinal, total: total, q: q };
  }
  /* v1.2: envio directo a GA4 (gtag lazy) */
  var GA4_ID = 'G-VD25X90WHN';
  var lastGa4Cp = null;
  function ga4(cp, covered, autosw){
    try {
      if (cp === lastGa4Cp) return; /* dedupe: mismo CP no se re-manda */
      lastGa4Cp = cp;
      if (!window.__labetaGtag) {
        window.dataLayer = window.dataLayer || [];
        window.__labetaGtag = function(){ window.dataLayer.push(arguments); };
        window.__labetaGtag('js', new Date());
        window.__labetaGtag('config', GA4_ID, { send_page_view: false });
        var s = document.createElement('script');
        s.async = true;
        s.src = 'https://www.googletagmanager.com/gtag/js?id=' + GA4_ID;
        document.head.appendChild(s);
      }
      window.__labetaGtag('event', 'cp_check', {
        cp_cubierto: covered ? 'si' : 'no',
        estado_auto: autosw ? 'si' : 'no'
      });
    } catch(e) {}
  }
  var state = { cp: null, res: null };
  function fmt(n){ return '$' + n.toLocaleString('es-MX'); }
  function render(){
    var out = document.getElementById('labetaCpResult');
    if (!out) return;
    if (!state.cp || !state.res) { out.style.display = 'none'; return; }
    var r = state.res;
    out.style.display = 'block';
    out.innerHTML = '<strong>Precio entregado en tu CP ' + state.cp + ':</strong> ' +
      fmt(r.unit) + ' /m² + IVA' +
      '<span style="display:block;color:#8a8a8a;font-size:11px;margin-top:2px">' +
      r.q + ' m² ≈ ' + fmt(r.total) + ' + IVA · entrega a domicilio incluida</span>';
  }
  function recompute(){
    if (!state.cp) return;
    state.res = compute(state.cp);
    render();
  }
  function update(){
    var inp = document.getElementById('labetaCpInput');
    if (!inp) return;
    var v = (inp.value || '').replace(/\D/g, '').slice(0, 5);
    if (inp.value !== v) inp.value = v;
    if (v.length === 5) {
      state.cp = v;
      var switched = autoState(v); /* v1.1: alinear el Estado con el CP */
      state.res = compute(v);
      if (switched) { setTimeout(recompute, 350); } /* re-leer precio tras repintado */
      try { sessionStorage.setItem('labeta_cp', v); } catch(e) {}
      try { window.dataLayer = window.dataLayer || []; window.dataLayer.push({ event: 'cp_check', cp_cubierto: state.res && state.res.covered, estado_auto: switched }); } catch(e) {}
      if (state.res) { ga4(v, state.res.covered, switched); }
    } else {
      state.cp = null; state.res = null;
    }
    render();
  }
  function deferUpdate(){ setTimeout(recompute, 250); }
  function inject(){
    var card = document.querySelector('.labeta-cotizador');
    if (!card || document.getElementById('labetaCpInput')) return;
    var wrap = document.createElement('div');
    wrap.setAttribute('style', 'margin:12px 0');
    wrap.innerHTML =
      '<label for="labetaCpInput" style="display:block;font-size:11px;color:#999;margin-bottom:6px;letter-spacing:.5px;text-transform:uppercase">📍 Código postal de entrega</label>' +
      '<input type="text" id="labetaCpInput" inputmode="numeric" autocomplete="postal-code" maxlength="5" placeholder="Ej. 45030" style="width:100%;padding:10px 12px;border:1px solid #e0ddd6;border-radius:4px;font-size:14px;background:#faf9f7;height:42px;box-sizing:border-box">' +
      '<div id="labetaCpResult" style="display:none;margin-top:8px;font-size:13px;color:#1a1a1a;background:#f4f1ea;border:1px solid #e5dfd2;border-radius:6px;padding:10px 12px"></div>';
    var form = card.querySelector('form');
    if (form && form.parentNode === card) { card.insertBefore(wrap, form.nextSibling); }
    else { card.appendChild(wrap); }
    var inp = document.getElementById('labetaCpInput');
    inp.addEventListener('input', update);
    try { var saved = sessionStorage.getItem('labeta_cp'); if (saved) { inp.value = saved; update(); } } catch(e) {}
    var q = document.getElementById('Quantity');
    if (q) { q.addEventListener('input', deferUpdate); q.addEventListener('change', deferUpdate); }
    var sels = document.querySelectorAll('.single-option-selector');
    for (var i = 0; i < sels.length; i++) { sels[i].addEventListener('change', deferUpdate); }
    document.addEventListener('click', function(ev){
      var a = ev.target && ev.target.closest ? ev.target.closest('#labetaWaCotizar') : null;
      if (!a || !state.cp || !state.res) return;
      try {
        var url = new URL(a.href);
        var txt = url.searchParams.get('text') || '';
        if (txt.indexOf('CP ' + state.cp) === -1) {
          txt += ' · CP ' + state.cp + ' · precio entregado ' + fmt(state.res.unit) + '/m2 + IVA';
          url.searchParams.set('text', txt);
          a.href = url.toString();
        }
      } catch(e) {}
    }, true);
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', inject); }
  else { inject(); }
})();